"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, "Vue app"));
}
exports.render = render;
